import { Theme } from "../Interfaces/Interfaces";

const PrimaryTheme: Theme = {
  primary: '#296cf0',
  appBar: '#296cf0',
  variant: '#c973a7',
  textPrimary: '#713779',
  dark: '#4D4F5C',
  light: '#b0b8bb',
  icon: '#974578',
  info: '#56D9FE',
  purple: '#673AB7',
  success: '#3ACC6C',
  lightGreen: 'rgba(95, 227, 161,  .3)',
  white: '#ffffff',
  background: '#F4F2F2',
  warn: '#ffb62d',
  black: '#282828',
  active: '#974578',
  danger: '#ff3d71',
  text: '#282828',
  surface: '#f4f2f2',
  secondary: '#b79cff',
  onBackground: '#000',
  onSurface: '#000',
  onPrimary: '#fff',
  borderColor: '#f0f3f5',
  google: '#ea4335',
  facebook: '#1877f2',
  apple: '#282828',
  placeholderColor: '#818E94',
  onSecondary: '#000',
  bqDanger: '#ff647e',
  bqDangerBackground: '#ff647e33',
  bqWarning: ' #ffe564',
  bqWarningBackground: ' #ffe56433',
  bqInfo: '#64ccff',
  bqInfoBackground: '#64ccff33',
  fonts: {
    Avenir: 'Avenir',
    AvenirMedium: 'AvenirMedium',
    RubikRegular: "RubikRegular",
    RubikMedium: "RubikMedium",
    RubikLight: "RubikLight",
    RubikItalic: "RubikItalic",
    RubikBold: "RubikBold",
    RegularFont: "RegularFont",
    MediumFont: "MediumFont",
    LightFont: "LightFont",
    ItalicFont: "ItalicFont",
    BoldFont: "BoldFont"
  },
  fontSizes: {
    heading: 42,
    title: 26,
    body: 18,
    subtitle: 20,
    small: 12,
    normal: 14,
    anchor: 16
  }
}

export default PrimaryTheme;